import { api } from 'src/boot/axios'
import { AuthResponse } from 'src/types/api/auth'

const Auth = {
  csrf: async () => {
    await api.get('csrf-cookie')
  },

  user: async (): Promise<AuthResponse> => {
    return await api.get('profile')
  },

  logout: async (): Promise<void> => {
    await api.get('logout').catch(() => void 0)
  },
}

export default Auth
